<template>
      <article class="card-product-cart">
                <div class="img-product">
                    <img :src="product.img_product[0] || 'https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png'" :alt="product.description_product_custom" />
                </div>
                <div class="info-product">
                    <aside class="info-product__details">
                        <h2>{{ product.name_product }}</h2>
                        <p>{{ product.description_product_custom }}</p>
                        <p>Marca: {{ product.brand_product }}</p>
                    </aside>     
                    <aside class="info-product__actions">
                        <div class="info-product__quantity">
                            <label for="quantity">Cantidad</label>
                            <input type="number" class="input-product__product__quantity" id="quantity" :value="product.quantity" @change="(e) => onChangeQuantity(product.id, e)"/>
                        </div>
                        <div class="button button-remove">
                            <button @click="() => removeProductToCart(product.id)">Quitar</button>
                        </div>
                    </aside>         
                </div>
            </article>
</template>

<script lang="ts" setup>
import {defineProps} from 'vue';
import { useCartShoppingStore } from '@/store/cartshopping';
const cartShop = useCartShoppingStore();


defineProps({
    product: {
        type: Object,
        required: true
    }
})
function onChangeQuantity(id, e) {
    const existingProduct = cartShop.cart.find(item => item.id === id);
    if (existingProduct) {
        existingProduct.quantity = Number(e.target.value);
        return;
    }
}

function removeProductToCart(id: number) {
    cartShop.removeFromCart(id)
}

</script>

<style lang="scss" scoped>
.card-product-cart {
        display: flex;
        flex-direction: row;
        gap: 20px;
        align-items: center;
        background-color: white;
        border-radius: 5px;
        padding-block: 10px;
        .img-product {
            padding-block: 10px;
        }
        img {
            width: 250px;
            height: 150px;
            object-fit: contain;
            border-radius: 12px;
        }                        
        .info-product {
            display: flex;
            flex-direction: column;
            text-align: start;
            gap: 30px;
            h2 {
                font-size: 20px;
                font-weight: 600;
            }
            p {
                font-size: 16px;
                font-weight: 500;
            }
        }
        .info-product__actions {
            display: flex;
            flex-direction: row;
            align-items: end;
            gap: 30px;
            .info-product__quantity {
                display: flex;
                flex-direction: column;
                gap: 10px;
                .input-product__product__quantity {
                    width: 100px;
                    padding: 10px;
                    border-radius: 5px;
                    border: 1px solid #ccc;
                    font-size: 16px;
                }
            }
            .button-remove {
                    button {
                        background-color: #b4b4b4;
                        color: white;
                        padding: 10px 20px;
                        border-radius: 5px;
                        border: none;
                        cursor: pointer;
                        font-size: 16px;
                    }
                }
        }
    }

@media (max-width: 1600px) {
    .card-product-cart {
        padding-inline-end: 50px;
         img {
            width: 180px;
            height: 150px;
            object-fit: contain;
            border-radius: 12px;
        }    
    }
}
@media (max-width: 950px) {
     .card-product-cart {
         img {
            width: 120px;
            height: 100px;
            object-fit: contain;
            border-radius: 12px;
        }    
    }
}
</style>